import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { useSearchBox } from "react-instantsearch";

const SearchComponent = ({ onFocus }) => {
  const { refine, query } = useSearchBox();

  return (
    <TextField
      placeholder="Search"
      onChange={(e) => refine(e.target.value)}
      value={query}
      onFocus={onFocus}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchComponent;
